import React from "react";
import { CommonHelper } from "./common-helper";

export const lazyWithDelay = <T extends React.ComponentType<any>>(
  importFunc: () => Promise<{ default: T }>,
  delayMs = 0
): React.LazyExoticComponent<T> => {
  const isDev = CommonHelper.environment.isDevelopment();

  if (!isDev) 
    return React.lazy(importFunc);

  // In development: delay the import to simulate slow network
  return React.lazy(() =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve(importFunc());
      }, delayMs);
    })
  );
};
